export default __webpack_public_path__ + "static/media/headerBg.b002bb5f.jpg";